﻿export function initFAQPage() {
    const selector = document.querySelector('[data-faq-category-selector="true"]');
    const categoryCards = document.querySelectorAll("[data-faq-category-index]");

    if (!(selector instanceof HTMLSelectElement) || categoryCards.length === 0) {
        return;
    }

    selector.addEventListener("change", setCardsHidden);
    updateCategoryCards(selector);
}

function setCardsHidden(event) {
    const selector = event.currentTarget;

    if (!(selector instanceof HTMLSelectElement)) {
        return;
    }

    updateCategoryCards(selector);
}

function updateCategoryCards(selector) {
    const selectedIndex = selector.value;
    const categoryCards = document.querySelectorAll("[data-faq-category-index]");

    categoryCards.forEach(toggleCategoryCard.bind(null, selectedIndex));
}

function toggleCategoryCard(selectedIndex, card) {
    if (!(card instanceof HTMLElement)) {
        return;
    }

    card.hidden = selectedIndex === ""
        || card.getAttribute("data-faq-category-index") !== selectedIndex;
}